export default {
  SET_NOTIFICATION_TOKEN(state, data) {
    state.notificationMsg = data;
  },
  SET_HEADER_TITLE(state, data) {
    state.headerTitle = data;
  },
  SET_UNLEASH_FLAGED(state, data) {
    state.unleashEnalbed = data ? data : localStorage.getItem("isEnable");
  },
};
